import { useQuery } from '@tanstack/react-query'

import { identityServices } from '../identityServices'
import { QUERY_KEYS } from '@/constants/queryKeys'

export interface GetProfileParams {
  user_id: string
}

export const useGetProfile = ({ user_id }: GetProfileParams) =>
  useQuery({
    queryKey: [QUERY_KEYS.IDENTITY_PROFILE, user_id],
    queryFn: () => identityServices.getUserProfile(user_id),
    enabled: !!user_id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
